
<script>
  export let height;
</script>

<style>
  svg {
    display: inline-block;
  }

  svg path, svg rect {
    fill: white;
  }

  svg path.blue {
    fill: #009FDB;
  }
</style>


<svg width="{height}" height="{height}" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M68.6367 65.2735H3.23875C1.37024 65.2735 0 63.7786 0 62.0347V10.0901C0 8.22156 1.49481 6.85132 3.23875 6.85132H68.6367C70.5052 6.85132 71.8754 8.34613 71.8754 10.0901V61.9101C72 63.7786 70.5052 65.2735 68.6367 65.2735Z" fill="white"/>
  <path class="blue" d="M3.36332 0H68.5121C70.3806 0 71.8754 1.49481 71.8754 3.36332V34.1315H57.9239L51.5709 48.8305L42.2284 26.2837L33.1349 47.0865H0V3.36332C0 1.49481 1.49481 0 3.36332 0Z" fill="#009FDB"/>
  <path class="blue" d="M72 37.2457V68.6367C72 70.5052 70.5052 72 68.6367 72H3.36332C1.49481 72 0 70.5052 0 68.6367V50.2007H35.6263L41.9792 35.5017L51.3218 58.0484L60.4152 37.2457H72Z" fill="#009FDB"/>
</svg>
